<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('company.attributes') }}</span></li>
				</ul>
			</div>
		</div>


		<div id="toolbar" class="toolbar">
			<button id="attributes_table_toolbar_add" title="add">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('add') }}</span>
			</button>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>

import { AttributesManager } from '@/core/administration/AttributesManager'
import { Table } from '@/core/support_gui_components/table/table'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex } from '@/core/shared'
import '@/core/input_controls/fileUploader/fileUploader'
import { CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST } from 'actions/configurations'

export default {
	name: 'CompanyAttributes',
	metaInfo () {
		return {
			title: this.$t('company.attributes')
		}
	},
	props: [
		'id',
		'admin'
	],
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'title': 'attributes.config.type',
				'columnName': 'type_name',
				'attribute': 'type_name'
			},
			{
				'title': 'attributes.config.uploaded',
				'columnName': 'uploaded',
				'attribute': 'uploaded'
			},
			{
				'title': 'attributes.config.download',
				'columnName': 'download',
				'attribute': 'download'
			}
		]

		let companyId = this.id || this.$store.getters.getProfile.companyId

		window.manager = new AttributesManager(companyId)
		window.downloadManager = downloadManager

		window.table = new Table('attributesTable', {
				selector: '#table',
				columns: tableColumns,
				dynamicLoading: false,
				contextMenu: '#context-menu',
				doubleClickMode: 'edit',
				frozen: 'none'
			},
			{
				contextMenu: {
					1: function (item, attribute) {
						initAttributesManager('edit', item, item.companyId, attribute)
					}
				},
				doubleClick: {
					'edit': function (item, table) {
						table.callbacks.contextMenu['1'](item, table.selectedAttribute)
					}
				}
			},
			function (data) {
				manager.prepareData(data)
			})

		manager.initTable(table)

		bindResetButton()
		removeTabindex()

		$('#attributes_table_toolbar_add').click(function () {
			initAttributesManager('create', undefined, companyId, '')
		})
		$(':file').filestyle({ buttonText: 'choose.file' })

		function initAttributesManager (action, attribute, companyId, activeAttribute) {
			manager.setProperties({
				action: action,
				activeAttribute: activeAttribute,
				attribute: attribute,
				companyId: companyId,

				postSaveAction: function () {
					manager.updateAttributesTable(table)
					vm.$store.dispatch(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, [])
				}
			})
			manager.initAttributesManager(action)
		}
	}
}
</script>

<style scoped>

</style>
